module.exports = __webpack_public_path__ + "static/media/star_active.2aebb286.svg";